import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/lib/push";
import { installBackgroundRefresh } from "@/lib/refresh";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker for PWA + Web Push (skipped if unsupported).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    registerSW();
  });
}

// Background refresh: re-fetch data when the user returns to the tab,
// regains connectivity, or a push notification arrives. Keeps the UI
// fresh without forcing a manual reload.
installBackgroundRefresh();
